<script setup>

import Button from "../Atomic/Button.vue";

const props = defineProps({
  isLateSimpleshopRegistrationOpened: Boolean,
  lateSimpleshopRegistrationStart: String,
  lateSimpleshopRegistrationEnd: String,
})
</script>

<template>
  <div class="rounded-[20px] relative bg-white pb-[5px] h-full" style="box-shadow: -1px 1px 4px 0 rgba(102, 102, 102, 0.50);">
    <div v-if="!isLateSimpleshopRegistrationOpened"
         class=" rounded-[20px] absolute opacity-30 h-full w-full bg-gray-600"></div>
    <div class="p-6 flex flex-col">
      <p class="text-gray-500 text-[48px] font-medium md:mb-4 md:mt-4 mb-2 mt-1" style="line-height: 75%;">2 990 Kč <span class="text-gray-500 text-[16px] font-medium whitespace-nowrap">bez DPH</span>
      </p>
      <p class="text-[#2699C6] text-[24px] font-semibold mb-[12px]">Standard Late Bird</p>
      <p class="text-[#666] text-[16px] md:mb-[30px] mb-[10px] font-semibold" style="line-height: 24px">Zajistěte si vstup na Shopcamp a zažijte den plný vzdělávání, zábavy a networkingu.
      </p>
      <div class="flex flex-col gap-1.5 my-[20px]">
        <div class="flex flex-row items-center">
          <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M36.6693 20.6413C36.6693 29.8459 29.2073 37.3079 20.0026 37.3079C10.7979 37.3079 3.33594 29.8459 3.33594 20.6413C3.33594 11.4365 10.7979 3.97461 20.0026 3.97461C29.2073 3.97461 36.6693 11.4365 36.6693 20.6413ZM26.7198 15.5907C27.2079 16.0789 27.2079 16.8703 26.7198 17.3584L18.3864 25.6918C17.8983 26.1799 17.1069 26.1799 16.6187 25.6918L13.2854 22.3584C12.7972 21.8703 12.7972 21.0789 13.2854 20.5908C13.7735 20.1026 14.565 20.1026 15.0532 20.5908L17.5026 23.0401L21.2273 19.3154L24.9521 15.5907C25.4403 15.1026 26.2316 15.1026 26.7198 15.5907Z"
                  fill="#A6C71F"/>
          </svg>
          <p class="text-[#666] text-[16px] font-medium ml-2">Přednášky</p>
        </div>
        <div class="flex flex-row items-center">
          <div class="w-[40px] h-[41px]">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.6693 20.6413C36.6693 29.8459 29.2073 37.3079 20.0026 37.3079C10.7979 37.3079 3.33594 29.8459 3.33594 20.6413C3.33594 11.4365 10.7979 3.97461 20.0026 3.97461C29.2073 3.97461 36.6693 11.4365 36.6693 20.6413ZM26.7198 15.5907C27.2079 16.0789 27.2079 16.8703 26.7198 17.3584L18.3864 25.6918C17.8983 26.1799 17.1069 26.1799 16.6187 25.6918L13.2854 22.3584C12.7972 21.8703 12.7972 21.0789 13.2854 20.5908C13.7735 20.1026 14.565 20.1026 15.0532 20.5908L17.5026 23.0401L21.2273 19.3154L24.9521 15.5907C25.4403 15.1026 26.2316 15.1026 26.7198 15.5907Z"
                    fill="#A6C71F"/>
            </svg>
          </div>
          <p class="text-[#666] text-[16px] font-medium ml-2">2 workshopy a mastermindy</p>
        </div>
        <div class="flex flex-row items-center">
          <div class="w-[40px] h-[41px]">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.6693 20.6413C36.6693 29.8459 29.2073 37.3079 20.0026 37.3079C10.7979 37.3079 3.33594 29.8459 3.33594 20.6413C3.33594 11.4365 10.7979 3.97461 20.0026 3.97461C29.2073 3.97461 36.6693 11.4365 36.6693 20.6413ZM26.7198 15.5907C27.2079 16.0789 27.2079 16.8703 26.7198 17.3584L18.3864 25.6918C17.8983 26.1799 17.1069 26.1799 16.6187 25.6918L13.2854 22.3584C12.7972 21.8703 12.7972 21.0789 13.2854 20.5908C13.7735 20.1026 14.565 20.1026 15.0532 20.5908L17.5026 23.0401L21.2273 19.3154L24.9521 15.5907C25.4403 15.1026 26.2316 15.1026 26.7198 15.5907Z"
                    fill="#A6C71F"/>
            </svg>
          </div>
          <p class="text-[#666] text-[16px] font-medium ml-2">Vstup na afterparty</p>
        </div>
        <div class="flex flex-row items-center">
          <div class="w-[40px] h-[41px]">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.6693 20.6413C36.6693 29.8459 29.2073 37.3079 20.0026 37.3079C10.7979 37.3079 3.33594 29.8459 3.33594 20.6413C3.33594 11.4365 10.7979 3.97461 20.0026 3.97461C29.2073 3.97461 36.6693 11.4365 36.6693 20.6413ZM26.7198 15.5907C27.2079 16.0789 27.2079 16.8703 26.7198 17.3584L18.3864 25.6918C17.8983 26.1799 17.1069 26.1799 16.6187 25.6918L13.2854 22.3584C12.7972 21.8703 12.7972 21.0789 13.2854 20.5908C13.7735 20.1026 14.565 20.1026 15.0532 20.5908L17.5026 23.0401L21.2273 19.3154L24.9521 15.5907C25.4403 15.1026 26.2316 15.1026 26.7198 15.5907Z"
                    fill="#A6C71F"/>
            </svg>
          </div>
          <p class="text-[#666] text-[16px] font-medium ml-2">Doprovodný program a networking</p>
        </div>
        <div class="flex flex-row items-center">
          <div class="w-[40px] h-[41px]">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.6693 20.6413C36.6693 29.8459 29.2073 37.3079 20.0026 37.3079C10.7979 37.3079 3.33594 29.8459 3.33594 20.6413C3.33594 11.4365 10.7979 3.97461 20.0026 3.97461C29.2073 3.97461 36.6693 11.4365 36.6693 20.6413ZM26.7198 15.5907C27.2079 16.0789 27.2079 16.8703 26.7198 17.3584L18.3864 25.6918C17.8983 26.1799 17.1069 26.1799 16.6187 25.6918L13.2854 22.3584C12.7972 21.8703 12.7972 21.0789 13.2854 20.5908C13.7735 20.1026 14.565 20.1026 15.0532 20.5908L17.5026 23.0401L21.2273 19.3154L24.9521 15.5907C25.4403 15.1026 26.2316 15.1026 26.7198 15.5907Z"
                    fill="#A6C71F"/>
            </svg>
          </div>
          <p class="text-[#666] text-[16px] font-medium ml-2">Občerstvení během dne (kromě oběda)</p>
        </div>
      </div>

      <Button v-if="isLateSimpleshopRegistrationOpened" class="bg-[#2699C6] text-white max-w-[200px]"
              :href="route('frontend.registration-standard')">
        <p class="py-[10px]">Registrace</p>
      </Button>
      <Button v-else class="bg-gray-500 disabled text-white max-w-[200px]">
        <p class="py-[10px]">Nespuštěno</p>
      </Button>
      <p v-if="isLateSimpleshopRegistrationOpened" class="text-gray-500 text-[16px] font-medium mt-[30px]"
         style="line-height: 24px">Vstupenky Standard se prodávají
        do {{ lateSimpleshopRegistrationEnd }} nebo do vyprodání.</p>
      <p v-else class="text-gray-500 text-[16px] font-medium mt-[30px]" style="line-height: 24px">Late Bird vstupenky
        Standard se budou prodávat
        od {{ lateSimpleshopRegistrationStart }}.</p>
    </div>
  </div>

</template>

<style scoped>

</style>
